import classNames from "classnames";
import styles from "../Digikala.module.css";

export default function DigikalaPrices({ prices }) {
  return (
    <div className="row rtl d-flex justify-content-center flex-wrap py-4 mt-5">
      <div className="col-12">
        <h2 className="text-secondary font-weight-bold h3 text-center mb-0">
          {prices.title}
        </h2>
      </div>

      <div className="col-12 d-flex justify-content-center pt-3 row rtl flex-wrap w-100">
        {prices.cards.map((item, idx) => (
          <div
            key={idx}
            className={classNames(
              "col-12 col-sm-6 col-md-6 col-lg-4 p-2",
              styles.digikalaPriceCard
            )}
          >
            <div className={classNames("card shadow", styles.digikalaCard)}>
              <div className="card-body">
                <div className="row rtl d-flex justify-content-center flex-wrap text-center ">
                  <div className="col-6 pb-2">
                    <img
                      src="/digikala/location.png"
                      style={{ maxHeight: 30 }}
                      alt="لوکیشن"
                    />
                    <h3 className="h6" style={{ color: "#482b88" }}>
                      {item.source}
                    </h3>
                  </div>
                  <div className="col-6 pb-2">
                    <img
                      src="/digikala/location.png"
                      style={{ maxHeight: 30 }}
                      alt="لوکیشن"
                    />
                    <h3 className="h6" style={{ color: "#482b88" }}>
                      {item.destination}
                    </h3>
                  </div>
                </div>
                <div className="col-12">
                  <div
                    className={classNames("card", styles.digikalaGhostwhite)}
                  >
                    <div className="card-body text-center">
                      <p className="h5">هزینه ارسال</p>
                      <p className="h5" style={{ color: "#482b88" }}>
                        <span>{item.finalPrice}</span>
                        <span> تومان</span>
                      </p>
                      <p className={styles.digikalaDiscount}>
                        <span>{item.largePrice}</span>
                        <span> تومان</span>
                      </p>
                    </div>
                  </div>
                </div>

                <div className="col-12 pt-2">
                  <div className="card">
                    <div className="card-body text-center">
                      <div className="border rounded p-2 my-2 h6 gap-1 d-flex justify-content-center align-items-center">
                        <img
                          src="/digikala/weight.svg"
                          className={styles.digikalaIcon}
                          alt="weight"
                        />
                        <span>
                          <span>{item.weight}</span>
                          <span> کیلوگرم</span>
                        </span>
                      </div>

                      <div className="border rounded p-2 my-2 h6 gap-1 d-flex justify-content-center align-items-center">
                        <img
                          src="/digikala/box.png"
                          className={styles.digikalaIcon}
                          alt="weight"
                        />
                        <span>کارتن سایز </span>
                        <span>{item.boxSize}</span>
                      </div>
                      <div className="border rounded p-2 my-2 h6 gap-1 d-flex justify-content-center align-items-center">
                        <img
                          src="/digikala/money.png"
                          className={styles.digikalaIcon}
                          alt="weight"
                        />
                        <span className="small">ارزش مرسوله </span>
                        <span>{item.parcelValue}</span>
                        <span className="small"> میلیون تومان</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
